import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const WorshipBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative aspect-[4/3] overflow-hidden sm:aspect-auto sm:h-[60vh] sm:min-h-[360px] lg:h-[85vh]" data-testid="worship-band">
      <motion.img
        src="/images/worship-arms-open.webp"
        alt="Worshipper with arms open during a church service"
        style={{ y, scale: 1.25 }}
        className="absolute inset-0 h-full w-full object-cover object-[55%_40%]"
      />
      <div className="absolute inset-x-0 bottom-0 mx-auto max-w-[1440px] px-5 pb-6 sm:px-8 sm:pb-10 lg:px-12 lg:pb-14">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl font-display text-2xl leading-tight text-white [text-shadow:0_2px_18px_rgba(0,0,0,0.7)] sm:text-5xl"
        >
          Strengthening <em className="italic text-[#E09838]">worship</em> environments.
        </motion.p>
      </div>
    </section>
  );
};
